import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import router from './router'
import store from './store'
import './assets/style.css';

import {
  Button, Icon, Tab, Tabs, Grid, GridItem, Image, RadioGroup, Radio, Step, Steps, 
  Col, Row, Skeleton, Progress, Popup, Swipe, SwipeItem, Card, Tag, Divider,
  Dialog, Toast, Notify
} from 'vant';

/* import Vconsole from 'vconsole'

const vConsole =new Vconsole();
Vue.use(vConsole) */



Vue.use(Button)
Vue.use(Icon)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Image)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Col)
Vue.use(Row)
Vue.use(Skeleton)
Vue.use(Progress)
Vue.use(Popup)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Card)
Vue.use(Tag)
Vue.use(Divider)

Vue.use(Dialog)
Vue.use(Toast)
Vue.use(Notify)

Vue.use(Vuex)

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
